import { useMutation, UseMutationOptions } from 'react-query';
import { mutateVoidProposition } from './voidProposition';
import { TVoidPropositionBody } from './voidProposition.types';

export const useMutationVoidProposition = (
  options?: UseMutationOptions<unknown, unknown, TVoidPropositionBody>
) => useMutation((data) => mutateVoidProposition(data), options);
